import React from 'react';

export const Prose = ({ children, className = '' }) => {
  return (
    <div className={`prose ${className}`}>
      {children}
    </div>
  );
};

export const ProseParagraph = ({ children, className = '' }) => {
  return (
    <p className={`text-foreground leading-relaxed ${className}`}>
      {children}
    </p>
  );
};

export const ProseList = ({ items, className = '' }) => {
  return (
    <ul className={`space-y-2 mb-5 ${className}`}>
      {items.map((item, index) => (
        <li 
          key={index}
          className="relative pl-7 text-foreground leading-relaxed"
        >
          <span className="absolute left-0 top-0 text-muted-foreground">–</span>
          {item}
        </li>
      ))}
    </ul>
  );
};

export const ProseEmphasis = ({ children, className = '' }) => {
  return (
    <em className={`font-serif italic ${className}`}>
      {children}
    </em>
  );
};

export default Prose;
